<template>
  <div>
    <div class="banner-sec">
      <div class="banner banner-joinus">
        <div class="wd1">
          <h2 class="banner-title-main">联系我们</h2>
        </div>
      </div>
    </div>
    <div class="cp-one-2">
      <div class="wd clearfix">
        <div class="cp-img-wrap">
          <img src="/static/address.png" alt="公司地址" class="cp-img address-img">
        </div>
        <div class="cp-one-right">
          <h2 class="g-h3-title">联系我们</h2>
          <div class="right-style">
            <p class="cp-option"><i class="fa fa-phone-square"></i> &nbsp;&nbsp;&nbsp;&nbsp;010-85788727</p>
            <p class="cp-option"><i class="fa fa-map-marker"></i> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京市朝阳区常通路3号院长楹星座一栋2302</p>
            <p class="cp-option"><i class="fa fa-envelope"></i> &nbsp;&nbsp;&nbsp;&nbsp;txbusiness@tianxingshuke.com</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Partner',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cp-img-wrap .address-img {
  width: 90%;
  max-height: 380px;
  margin: 0 auto;
  display: block;
  object-fit: contain;
}
</style>


// WEBPACK FOOTER //
// src/components/Contact.vue